import * as React from "react";
import type { SVGProps } from "react";
const SvgInsightIntoAction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M0 52.034c0-.47.381-.852.852-.852h60.955a.852.852 0 0 1 0 1.704H.852A.852.852 0 0 1 0 52.034Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M19.945 52.034c0-.47.382-.852.852-.852h1.976a.852.852 0 0 1 0 1.704h-1.976a.852.852 0 0 1-.852-.852ZM39.355 52.034c0-.47.381-.852.852-.852h1.976a.852.852 0 0 1 0 1.704h-1.976a.852.852 0 0 1-.852-.852ZM4.38 32.576a.133.133 0 0 1 .027-.029.323.323 0 0 1 .139-.064h5.242c.115 0 .194.04.233.073a.113.113 0 0 1 .024.025V51.06a.13.13 0 0 1-.026.028.36.36 0 0 1-.231.075h-5.15a.365.365 0 0 1-.234-.073.114.114 0 0 1-.024-.026V32.576Zm1.11-1.797v-.01h-.852c-.953 0-1.961.69-1.961 1.797V51.07c0 1.122 1.014 1.796 1.961 1.796h5.15c.953 0 1.961-.689 1.961-1.796V32.575c0-1.122-1.014-1.796-1.961-1.796H5.49Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M16.024 21.796a.83.83 0 0 0-.147.5v28.268a.83.83 0 0 0 .147.5c.037.047.07.07.088.08.015.009.021.009.023.009h5.15s.006 0 .022-.008a.3.3 0 0 0 .088-.082.83.83 0 0 0 .147-.5V22.297a.83.83 0 0 0-.148-.5.3.3 0 0 0-.087-.08c-.015-.01-.021-.01-.023-.01h-5.15s-.007 0-.022.01a.298.298 0 0 0-.087.08Zm-1.85.5c0-1.05.684-2.293 1.96-2.293h5.15c1.277 0 1.962 1.243 1.962 2.293v28.268c0 1.05-.685 2.292-1.962 2.292h-5.15c-1.276 0-1.96-1.243-1.96-2.292V22.296ZM39.137 18.475a.258.258 0 0 0-.258.258v32.152c0 .143.115.258.258.258h5.15a.258.258 0 0 0 .257-.258V18.733a.258.258 0 0 0-.258-.258h-5.15Zm-1.962.258c0-1.083.879-1.961 1.962-1.961h5.15c1.082 0 1.96.878 1.96 1.961v32.152a1.961 1.961 0 0 1-1.96 1.962h-5.15a1.961 1.961 0 0 1-1.962-1.962V18.733ZM27.382 28.564V51.1a.588.588 0 0 0 .258.053h5.15c.119 0 .206-.028.258-.053V28.564a.588.588 0 0 0-.259-.053H27.64a.588.588 0 0 0-.258.053Zm-1.02-1.37a2.216 2.216 0 0 1 1.278-.386h5.15c.46 0 .915.13 1.277.387.36.255.684.686.684 1.253v22.768c0 .566-.323.998-.684 1.253a2.216 2.216 0 0 1-1.278.387H27.64c-.461 0-.916-.13-1.277-.387-.361-.255-.684-.687-.684-1.253V28.448c0-.567.323-.998.684-1.253Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M7.286 27.484a3.027 3.027 0 1 0 0-6.055 3.027 3.027 0 0 0 0 6.055Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M7.286 22.281a2.176 2.176 0 1 0 0 4.352 2.176 2.176 0 0 0 0-4.352Zm-3.88 2.176a3.88 3.88 0 1 1 7.759 0 3.88 3.88 0 0 1-7.758 0ZM18.87 11.593a2.176 2.176 0 1 0 0 4.351 2.176 2.176 0 0 0 0-4.35Zm-3.88 2.176a3.88 3.88 0 1 1 7.759 0 3.88 3.88 0 0 1-7.758 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M30.17 23.172a3.027 3.027 0 1 0 0-6.055 3.027 3.027 0 0 0 0 6.055Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M30.17 17.97a2.176 2.176 0 1 0 0 4.35 2.176 2.176 0 0 0 0-4.35Zm-3.879 2.175a3.88 3.88 0 1 1 7.759 0 3.88 3.88 0 0 1-7.758 0ZM41.647 7.826a2.176 2.176 0 1 0 0 4.351 2.176 2.176 0 0 0 0-4.351Zm-3.879 2.176a3.879 3.879 0 1 1 7.758 0 3.879 3.879 0 0 1-7.758 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M56.385 47.332v1.45a.76.76 0 0 1-.759.76h-4.994a.76.76 0 0 0-.759.76v3.309c0 .418.34.759.76.759h4.993c.419 0 .76.34.76.76v1.128a.763.763 0 0 0 1.255.584l5.237-4.468a.756.756 0 0 0 0-1.158l-5.237-4.468a.763.763 0 0 0-1.256.584Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M55.534 47.332c0-1.379 1.608-2.119 2.656-1.235l.004.003 5.235 4.466a1.608 1.608 0 0 1 0 2.459l-5.239 4.469c-1.048.884-2.656.144-2.656-1.236v-1.036h-4.901a1.612 1.612 0 0 1-1.611-1.611V50.3c0-.889.721-1.61 1.61-1.61h4.902v-1.359Zm1.703.191v1.26c0 .889-.722 1.61-1.61 1.61h-4.902v3.125h4.901c.89 0 1.611.722 1.611 1.611v.939l5.008-4.273-5.008-4.272ZM55.534 31.63c0-1.378 1.608-2.118 2.656-1.234l.004.003 5.235 4.466a1.608 1.608 0 0 1 0 2.458l-5.239 4.47c-1.048.883-2.656.143-2.656-1.236V39.52h-4.901a1.612 1.612 0 0 1-1.611-1.61V34.6c0-.89.721-1.611 1.61-1.611h4.902V31.63Zm1.703.192v1.26c0 .888-.722 1.61-1.61 1.61h-4.902v3.125h4.901c.89 0 1.611.722 1.611 1.61v.94l5.008-4.273-5.008-4.272Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M56.385 15.93v1.45a.76.76 0 0 1-.759.76h-4.994a.76.76 0 0 0-.759.759v3.31c0 .418.34.759.76.759h4.993c.419 0 .76.34.76.759v1.13a.763.763 0 0 0 1.255.583l5.237-4.468a.756.756 0 0 0 0-1.158l-5.237-4.468a.763.763 0 0 0-1.256.584Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M55.534 15.93c0-1.38 1.608-2.12 2.656-1.236l.004.004 5.235 4.466a1.608 1.608 0 0 1 0 2.458l-5.239 4.47c-1.048.883-2.656.143-2.656-1.236v-1.037h-4.901a1.612 1.612 0 0 1-1.611-1.61v-3.31c0-.89.721-1.611 1.61-1.611h4.902V15.93Zm1.703.19v1.26c0 .89-.722 1.611-1.61 1.611h-4.902v3.125h4.901c.89 0 1.611.722 1.611 1.61v.939l5.008-4.272-5.008-4.272Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInsightIntoAction;
